import {selectTempSelector, setData} from "@/store/slices/tempSlice";
import {useAppDispatch, useAppSelector} from "@/store";
import {useEffect} from "react";

export const useTempData = (name, initData) => {
    const temp = useAppSelector(selectTempSelector)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (name && !temp[name]){
            setData(initData, name)
        }
    }, []);

    const setTempData = (value, key) =>{
        dispatch(setData({
            key: key ?? name,
            value,
        }))
    }

    const getTempData = (key) =>{
        if (name){
            const keys = key ? `${name}.${key}`.split('.') : name.split('.');
            let data = {...temp}

            while (keys.length > 1) {
                const k = keys.shift();

                if (temp.hasOwnProperty(k)) {
                    data = data[k];
                }
            }
            return data[keys[0]];
        }
    }

    return {
        setTempData,
        getTempData,
        data: getTempData() ?? initData,
    }
}